<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'expressreconciliationForm',
		props: {

		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {
//this.extra.nodeid
		},
		methods: {
			beforeInit(next){
				next()
			},
			regestEvent(rule, fApi) {
				console.log(this.extra.billtime)
				fApi.setValue('billtime',this.extra.billtime)
			// 	let $son_supplier_goods = fApi.el('$son_supplier_goods')
			// 	$son_supplier_goods.setRelationId({
			// 		tabledataid: 'goodsid',
			// 		boxdataid: 'id'
			// 	})
			// 	$son_supplier_goods.store.form = this
			// 	let $son_supplier_goods_rule = fApi.getRule('$son_supplier_goods')
			// 	fApi.updateRule('$son_supplier_goods', {
			// 		on: {
			// 			...$son_supplier_goods_rule.on,
			// 			importtemplate: this.supplierGoodsImporttemplate,
			// 			export: this.supplierGoodsExport,
			
			// 		}
			// 	})
			},
		},
		components: {

		}
	}
</script>
